<template>

    <b-form-group >
      <label v-html="fieldsData.label[selectlang]"></label>

      <v-select
          :options="fieldsData['string-array']"
          :reduce="(item) => item.id"
          label="title"
          :value="fieldsData.id?parseInt(fieldsData.id):''" :placeholder="fieldsData.hint[selectlang]"
      @input="districtChanged($event,'new', fieldsData.name,fieldsData.resetField,fieldsData.visibleItem,fieldsData.hideItem,
      fieldsData.requiredItem,fieldsData.nonRequiredItem,fieldsData.autoReflectField)"/>
<!--      <small class="text-danger" v-if="fieldsData.id==''">{{ fieldsData.error[selectlang] }}</small>-->
<!--      <p v-if="fieldsData.fieldType === 'Spinner'&& fieldsData.visible==1">-->
<!--        {{fieldsData['string-array']}}-->
<!--      </p>-->
    </b-form-group>

</template>



<script>
import vSelect from "vue-select";
export default {

  // props: {
  //   fieldsData: Object,
  // },
  props: ['fieldsData','filteredCities','selectlang'],
  components: {
    vSelect,
  },

  data() {
    return {
      username: '',
      // errors: [],
      DataArray:{},
    };
  },
  created() {
    if (this.fieldsData.id) {
      // this.fieldsData.id = parseInt(this.fieldsData.id)
      // if (typeof this.fieldsData.id === 'number') {
      //   //   // If this.fieldsData.id is a number, convert it to a string
      //   this.fieldsData.id = this.fieldsData.id.toString();
      // }
      // this.fieldsData.id = this.fieldsData.id.split(',').map(item => parseInt(item.trim()));
      if (this.fieldsData.resetField !== '' && Object.prototype.hasOwnProperty.call(this.fieldsData, 'resetField')) {

        this.districtChanged(this.fieldsData.id, 'edit', this.fieldsData.name, this.fieldsData.resetField, this.fieldsData.visibleItem, this.fieldsData.hideItem,
            this.fieldsData.requiredItem, this.fieldsData.nonRequiredItem, this.fieldsData.autoReflectField)
      }
    }
    else{
      this.$emit('targetfield', this.fieldsData.targetField)
    }

    if (this.fieldsData.id && this.fieldsData.fieldType === 'Spinner') {
      // If it's not empty, set the initial value of DataArray[fieldsData.name] to fieldsData.id
      // this.personDesignation = 74;
      // alert(this.personDesignation);
      // this.DataArray[this.fieldsData.name]=this.fieldsData.id;
      // alert(this.DataArray[this.fieldsData.name] );
    }
  },
  methods :{
    UpdateValue(value) {
      // console.log(value);
      this.$emit('input', value)
    },
    districtChanged(districtid,action,fieldname,resetField,visibleItem,hideItem,requiredItem,nonRequiredItem,autoReflectField){

      const visibilityChanges = [];
      const requiredChanges = [];

      // Pushing visibleItem and hideItem into the visibilityChanges array
      if (visibleItem) {
        visibilityChanges.push("show:" + visibleItem);
      }

      if (hideItem) {
        visibilityChanges.push("hide:" + hideItem);
      }
      if (requiredItem) {
        requiredChanges.push("required:" + requiredItem);
      }

      if (nonRequiredItem) {
        requiredChanges.push("nonrequired:" + nonRequiredItem);
      }
// alert(visibilityChanges);
//       if(resetField =='city'){
        this.$emit('districtChange', districtid,action,fieldname, resetField,visibilityChanges,requiredChanges,autoReflectField);
      // }
      // else{
      //   this.$emit('districtChange', districtid, resetField,visibilityChanges,requiredChanges);
      // }
      this. UpdateValue(districtid);

    },


  },
}
</script>

<style>
/* Add your styles here */
</style>
